import { Component, ViewEncapsulation, Input, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';

import { Guarantee } from '../../../../guarantee/models/guarantee';
import { GuaranteeStatus } from '../../../../guarantee/models/guarantee-constants';
import { getGuaranteeRequestStatusTr } from '../../../../guarantee/utils/guarantee.utils';
import { TranslationService } from '../../../services/translation.service';
import { UNDERSCORE } from '../../../utils/constant';
import { DatePipe } from '../../../pipes/date.pipe';

@Component({
	selector: 'copo-result-guarantee-card',
	templateUrl: './result-card-guarantee.component.html',
	styleUrl: './result-card-guarantee.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		MatRippleModule,
		RouterLink,
		TranslateModule,
		DatePipe,
	],
})
export class ResultCardGuaranteeComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;

	@Input() guarantee!: Guarantee;
	readonly UNDERSCORE = UNDERSCORE;

	constructor(private readonly translationService: TranslationService) {}

	getStatusLabel(guarantee: Guarantee) {
		return getGuaranteeRequestStatusTr(this.translationService, guarantee.status);
	}

	getLongType(appType: string) {
		switch (appType) {
		case 'Magnelis-Solar':
			return this.translationService.getTR('guarantee.magnelissolar.long');
		case 'Magnelis-Building':
			return this.translationService.getTR('guarantee.magnelisbuilding.long');
		case 'Magnelis-Other application':
			return this.translationService.getTR('guarantee.magnelisothers.long');
		case 'Organic Coating':
			return this.translationService.getTR('guarantee.organiccoating.long');
		}
		return '';
	}

	isDraft(guarantee: Guarantee) {
		return guarantee.status === GuaranteeStatus.DRAFT;
	}

	isOpen(guarantee: Guarantee) {
		return guarantee.status === GuaranteeStatus.OPEN;
	}

	isOther(guarantee: Guarantee) {
		return guarantee.status === GuaranteeStatus.LAUNCH_ANALYSIS;
	}

	isSatisfied(guarantee: Guarantee) {
		return guarantee.status === GuaranteeStatus.SATISFIED;
	}

	isCertificateRequested(guarantee: Guarantee) {
		return guarantee.status === GuaranteeStatus.CERTIFICATE_REQUESTED;
	}

	isCertificateIssued(guarantee: Guarantee) {
		return guarantee.status === GuaranteeStatus.CERTIFICATE_ISSUED;
	}

	isRejected(guarantee: Guarantee) {
		return guarantee.status === GuaranteeStatus.REJECTED_BY_SUPLIER;
	}

	isCancelled(guarantee: Guarantee) {
		return guarantee.status === GuaranteeStatus.CANCELLED;
	}

	isUnknown(guarantee: Guarantee) {
		return !this.isDraft(guarantee)
			&& !this.isOpen(guarantee)
			&& !this.isOther(guarantee)
			&& !this.isSatisfied(guarantee)
			&& !this.isCertificateRequested(guarantee)
			&& !this.isCertificateIssued(guarantee)
			&& !this.isRejected(guarantee)
			&& !this.isCancelled(guarantee);
	}
}
